/**
 * Call audio-session ownership for *capture* / connected calls (Meet/Zoom-style).
 *
 * iOS Safari only allows mic capture when `navigator.audioSession.type` is
 * `play-and-record` or `auto`. Begin this epoch on Answer/Start — NOT while
 * ringing (PlayAndRecord routes ringtone to the earpiece on iPhone).
 */

import {
  beginCallAudioEpoch,
  endCallAudioEpoch,
  isCallAudioEpochActive,
  reassertPlayAndRecordAudioSession,
} from '../../utils/audioSession';

export function enterCallAudioSession() {
  return beginCallAudioEpoch();
}

export function exitCallAudioSession() {
  return endCallAudioEpoch();
}

export function acquireCallAudioSession() {
  return beginCallAudioEpoch();
}

export function releaseCallAudioSession() {
  return endCallAudioEpoch();
}

export function isCallAudioSessionHeld() {
  return isCallAudioEpochActive();
}

export function reassertCallAudioSession() {
  return reassertPlayAndRecordAudioSession();
}
